import { selector } from 'recoil'
import { FilterAPI } from '../api/api'
import { Product, Suggest } from './type'

export const getAsyncProducts = selector({
  key: 'getAsyncProducts',
  get: async () => (await FilterAPI.listProducts()) as Product[],
})

export const getAsyncSuggests = selector({
  key: 'getAsyncSuggests',
  get: async () => {
    const list = (await FilterAPI.listSuggests()) as Suggest[]

    return list.sort((a, b: string) => a.length - b.length)
  },
})
